import { Header, Input, Icon } from "semantic-ui-react";
import { useEffect, useState } from "react";

import Pagination from "../../../components/Pagination/Pagination.js";
import { TableComponent } from "../../../components/Table/table";
import BackButton from "../../../components/BackButton/BackButton";
import Loading from "../../../components/Loading/Loading";
import { api } from "../../../api/api.js";
import { fcm_response_url } from "../../../api/urls.js";
import moment from "moment";
import axios from "axios";
import unknownError from "../../../utils/unknownError.js";

const title = "FCM Response";
const apiUrl = fcm_response_url;
// const searchFeild = "fcm_response_data";
const headers = ["JSON", "Date"];
const bodyMap = (d, refetch) => {
  const parsed =
    typeof d.fcm_response_data === "string"
      ? JSON.parse(d.fcm_response_data)
      : d.fcm_response_data;

  return [
    <pre
      style={{
        whiteSpace: "pre-wrap", // preserve indentation + allow wrapping
        wordBreak: "break-word", // break long words if needed
        fontFamily: "monospace", // keep code-like look
        background: "#f5f5f5", // light gray background
        padding: "10px",
        borderRadius: "6px",
        overflowX: "auto", // add horizontal scroll if really necessary
      }}
    >
      {JSON.stringify(parsed, null, 2)}
    </pre>,
    moment(d.created_at).format("DD-MM-YYYY"),
  ];
};

const FCMResponse = () => {
  const [data, setData] = useState();
  const [search, setSearch] = useState("");
  const [refetcher, setRefetcher] = useState(false);

  const [limit, setLimit] = useState(25);
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState();

  useEffect(() => {
    const source = axios.CancelToken.source();
    const getData = async () => {
      setData();
      try {
        const res = await api.get(
          apiUrl + "?limit=" + limit + "&offset=" + offset,
          { cancelToken: source.token }
        );
        setData(res.data);
        setCount(res.data.count);
      } catch (err) {
        unknownError(err);
      }
    };
    getData();
    return () => {
      source.cancel();
    };
  }, [refetcher, limit, offset]);

  const refetch = () => {
    setRefetcher((v) => !v);
  };

  return (
    <>
      <BackButton />
      <div id="heading">
        <Header>{title}</Header>
        <div className="right">
          <Input
            type="text"
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            icon={<Icon name="search" link id="search-icon" />}
          />
        </div>
      </div>
      {data ? (
        <>
          <TableComponent
            headers={headers}
            body={
              data?.results
                ? data?.results?.map((d) => {
                    return bodyMap(d, refetch);
                  })
                : []
            }
            showbottom={false}
            disableHeaderPopup
          />
        </>
      ) : (
        <Loading />
      )}
      {count ? (
        <Pagination count={count} setLimit={setLimit} setOffset={setOffset} />
      ) : null}
    </>
  );
};

export default FCMResponse;
